import { FC } from "react"
import ThreeCircles from "../UI/Icons/ThreeCircles";

/**
 * Loader Props Interface
 * @interface LoaderProps
 */
interface LoaderProps {}

const Loader: FC<LoaderProps> = () => {
    return (
        <div className="loader-container">
            <ThreeCircles />
        </div>
    )
}

export default Loader